import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../api/api";
import Style from "../../assets/css/main.module.css";
import bkashIcon from "../../assets/images/bkash.svg";
import cardIcon from "../../assets/images/card.svg";
import nagadIcon from "../../assets/images/nagad.svg";
// import rocketIcon from "../../assets/images/rocket.svg";
import { drawerAction, setBookingId } from "../../store/features/deviceSlice";
// import visaIcon from '../../assets/images/visa.svg';

function Payment() {
  const { bookingId } = useSelector((state) => state.deviceSlice);
  const dispatch = useDispatch();
  const [paymentMode, setPaymentMode] = useState(null);
  const [loading, setLoading] = useState(false);
  const createPayment = async () => {
    setLoading(true);
    if (bookingId && paymentMode) {
      const res = await api.payment({
        payment_mode: paymentMode,
        booking_id: bookingId,
      });
      if (res.status === 201) {
        dispatch(drawerAction(false));
        dispatch(setBookingId(null));
        sessionStorage.removeItem("selectedItemsByTab");
        window.location.href = res.data.data.redirectURL;
      } else if (res.status === 422) {
        Object.values(res.data.data).forEach((error) => {
          toast.error(error[0]);
        });
      } else {
        toast.error("Server side error!Please try again later");
      }
    }
    setLoading(false);
  };
  return (
    <div className="w-100 h-100 px-2 px-md-4">
      <div className="payment-container">
        <div>
          <div className="d-flex align-items-center justify-content-center gap-2 w-100 flex-wrap pt-3">
            <button
              type="button"
              className={`border rounded ${paymentMode === "bkash" ? "border-2 border-primary" : ""}`}
              onClick={() => setPaymentMode("bkash")}
            >
              <img src={bkashIcon} alt="bkash" className={Style.paymentIcon} />
            </button>
            <button
              type="button"
              className={`border rounded ${paymentMode === "nagad" ? "border-2 border-primary" : ""}`}
              onClick={() => setPaymentMode("nagad")}
            >
              <img src={nagadIcon} alt="bkash" className={Style.paymentIcon} />
            </button>
            {/* <button
              type="button"
              className={`border rounded ${paymentMode === "rocket" ? "border-2 border-primary" : ""}`}
              onClick={() => setPaymentMode("rocket")}
            >
              <img
                src={rocketIcon}
                alt="rocket"
                className={Style.paymentIcon}
              />
            </button> */}
            <button
              type="button"
              className={`border rounded ${paymentMode === "ssl" ? "border-2 border-primary" : ""}`}
              onClick={() => setPaymentMode("ssl")}
            >
              <img src={cardIcon} alt="visa" className={Style.paymentIcon} />
            </button>
          </div>
        </div>
      </div>
      <div className="payment-bottom">
        {!loading && (
          <button
            type="button"
            disabled={!paymentMode}
            onClick={createPayment}
            className={`${Style.fs_16} ${Style.fw_600} ${paymentMode ? Style.bg_primary : "bg-secondary"} border-0 text-light w-100 cart-checkout-btn`}
          >
            Confirm Payment
          </button>
        )}
        {loading && (
          <button
            disabled
            type="button"
            className={`${Style.bg_primary} ${Style.fs_20} ${Style.fw_600} border-0 text-light w-100 cart-checkout-btn`}
          >
            <Spinner animation="border" role="status" size="sm">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </button>
        )}
      </div>
    </div>
  );
}

export default Payment;
